import initAuditReportsShow from '../common/audit_report_show'

Styxie.Initializers.StatsAuditReports = {
  show: (props) => initAuditReportsShow(props, true)
}
